<div class="align-center" *ngIf="countryCode$ | async as countryCode">
  <a
    class="df-tablet-up flex--center no-underline nordic-blue-900-text text-icon-primary"
    [finLink]="'/'"
    [finElemTracker]="'flight-selection-country-selector'"
    [finElemContext]="TRACKING_CONTEXT"
    [finElemType]="ElementTypes.BUTTON"
    [attr.aria-label]="
      ('menu.language' | finLocalization) +
      ' ' +
      ('countries.' + countryCode | lowercase | finLocalization) +
      ' - ' +
      (lang$ | async | uppercase)
    "
  >
    <div>
      <fcom-icon class="icon-medium ms-xxsmall-r" [name]="SvgLibraryIcon.LANGUAGE" />
    </div>
    <div>
      <span class="font-body-1 dn-laptop-down font-body-medium"
        >{{ 'countries.' + countryCode | lowercase | finLocalization }} - {{ lang$ | async | uppercase }}</span
      >
      <span class="font-body-1 dn-laptop-up font-body-medium">{{ countryCode }}/{{ lang$ | async | uppercase }}</span>
    </div>
  </a>
</div>
